import React from 'react';
import './CountdownContainerInspector.css';

function CountdownContainerInspector({ 
  func, 
  index, 
  onUpdate,
  isPhotoPickerOpen,
  setIsPhotoPickerOpen,
  photoPickerPosition,
  setPhotoPickerPosition,
  setActivePhotoPreview,
  bringToFront
}) {
  const handleDateChange = (value) => {
    onUpdate(index, {
      ...func.props,
      targetDate: value
    });
  };

  const handleTextChange = (value) => {
    onUpdate(index, {
      ...func.props,
      countdownText: value
    });
  };

  const handleLabelChange = (key, value) => {
    onUpdate(index, {
      ...func.props,
      countdownLabels: {
        ...(func.props.countdownLabels || {}),
        [key]: value
      }
    });
  };

  const handleMediaChange = (key, value) => {
    onUpdate(index, {
      ...func.props,
      mediaProps: {
        ...(func.props.mediaProps || {}),
        [key]: value
      }
    });
  };

  return (
    <div className="countdown-inspector">
      <div className="section">
        <h4>Background Image</h4>
        <div className="input-group">
          <label>Image URL</label>
          <div 
              className="image-preview"
              onClick={(e) => {
                console.log('Image preview clicked');
                                  // Only store the index - no handler function
                  setActivePhotoPreview({ index });
                  setIsPhotoPickerOpen(true);
                  bringToFront('photoPicker');
                  e.stopPropagation();
              }}
              title="Click to change photo"
            >
              {func.props.mediaProps?.src ? (
                <img 
                  src={func.props.mediaProps.src} 
                  alt="Preview"
                  onError={(e) => e.target.style.display = 'none'}
                  onLoad={(e) => e.target.style.display = 'block'}
                />
              ) : (
                <div className="empty-preview">
                  Click to select image
                </div>
              )}
            </div>
            <input
              type="text"
              value={func.props.mediaProps?.src || ''}
              onChange={(e) => handleMediaChange('src', e.target.value)}
              placeholder="Enter background image URL"
              className="full-width-input"
            />
        </div>
      </div>

      <div className="section">
        <h4>Countdown Settings</h4>
        <div className="input-group">
          <label>Target Date</label>
          <input
            type="datetime-local"
            value={func.props.targetDate || ''}
            onChange={(e) => handleDateChange(e.target.value)}
            className="full-width-input"
          />
        </div>

        <div className="input-group">
          <label>Countdown Text</label>
          <input
            type="text"
            value={func.props.countdownText || ''}
            onChange={(e) => handleTextChange(e.target.value)}
            placeholder="Enter text to display below countdown"
            className="full-width-input"
          />
        </div>
      </div>

      <div className="section">
        <h4>Labels</h4>
        <div className="labels-grid">
          <div className="input-group">
            <label>Days</label>
            <input
              type="text"
              value={func.props.countdownLabels?.days || ''}
              onChange={(e) => handleLabelChange('days', e.target.value)}
              placeholder="Days"
              className="full-width-input"
            />
          </div>
          <div className="input-group">
            <label>Hours</label>
            <input
              type="text"
              value={func.props.countdownLabels?.hours || ''}
              onChange={(e) => handleLabelChange('hours', e.target.value)}
              placeholder="Hours"
              className="full-width-input"
            />
          </div>
          <div className="input-group">
            <label>Minutes</label>
            <input
              type="text"
              value={func.props.countdownLabels?.minutes || ''}
              onChange={(e) => handleLabelChange('minutes', e.target.value)}
              placeholder="Minutes"
              className="full-width-input"
            />
          </div>
          <div className="input-group">
            <label>Seconds</label>
            <input
              type="text"
              value={func.props.countdownLabels?.seconds || ''}
              onChange={(e) => handleLabelChange('seconds', e.target.value)}
              placeholder="Seconds"
              className="full-width-input"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CountdownContainerInspector; 